export default {"src":"https://s.sylndr.com/c-960f75c/_next/static/media/price-benefits.fc58c079.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};